import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "keyToText",
})
export class KeyToTextPipe implements PipeTransform {
  transform(value: string): string {
    return value.replace(/_/g, " ").replace(/^\w/, (c) => c.toUpperCase());
  }
}
